import React from 'react';

export const pageMeta = {
  "name": "Web Validation API",
  "link": "/javascript/web-api/validation"
};

export default function JavascriptWebApiValidation() {
  return (
    <div className="p-6 max-w-3xl mx-auto">
      <h2 className="text-2xl font-semibold mb-2">Web Validation API</h2>
      <p>Route: /javascript/web-api/validation</p>
      <h3 className="mt-4 font-medium">sub_content</h3>
      <pre>{JSON.stringify(pageMeta, null, 2)}</pre>
    </div>
  );
}
